import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RoutingSlice } from '../app-state';

export const selectRoutingSlice = createFeatureSelector<RoutingSlice>('routingSlice');

export const selectPipelineReleaseViewRoute = createSelector(selectRoutingSlice, (routingSlice) => {
  return routingSlice.pipelineReleaseViewRoute;
});

export const selectDeliveryGuidOfPipelineReleaseView = createSelector(selectPipelineReleaseViewRoute, (pipelineReleaseViewRoute) => {
  return pipelineReleaseViewRoute.deliveryGuid;
});

export const selectMicrodeliveryIdOfPipelineReleaseView = createSelector(selectPipelineReleaseViewRoute, (pipelineReleaseViewRoute) => {
  return pipelineReleaseViewRoute.microdeliveryId;
});

export const selectPipelineIdOfPipelineReleaseView = createSelector(selectPipelineReleaseViewRoute, (pipelineReleaseViewRoute) => {
  return pipelineReleaseViewRoute.pipelineId;
});

export const selectPipelineRunKeyOfPipelineReleaseView = createSelector(selectPipelineReleaseViewRoute, (pipelineReleaseViewRoute) => {
  return pipelineReleaseViewRoute.pipelineRunKey;
});

export const selectPipelineRunIdOfPipelineReleaseView = createSelector(selectPipelineReleaseViewRoute, (pipelineReleaseViewRoute) => {
  return pipelineReleaseViewRoute.pipelineRunId;
});

export const selectExpectedCentralPolicyKeysOfPipelineReleaseView = createSelector(
  selectPipelineReleaseViewRoute,
  (pipelineReleaseViewRoute) => {
    return pipelineReleaseViewRoute.expectedCentralPolicyKeys;
  },
);
